import React from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

export default function About() {
  return (
    <>
      <Header />
      <h1>ЗДЕСЬ БУДЕТ О НАС</h1>
      <Footer />
    </>
  );
}
